import React from 'react'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import Expander from '../Expander'
import Text, { HeaderText } from '../Text'

export default function(notification, markRead, size = 1) {
  const { t } = useTranslation()

  return (
    <>
      <Expander size={size} id={notification.id}>
        <Text size={size}>
          <HeaderText size={size}>
            <Flex row={true} justifyBetween={true} alignStart={true}>
              {t('OUT_28_airbnb_export')}
            </Flex>
          </HeaderText>
        </Text>
      </Expander>
    </>
  )
}
